<template>
  <div class="container_box">
    <!--头部筛选区域-->
    <div class="filter_box">
      <Form ref="pageParams" :model="pageParams" :label-width="labelWidth" @submit.native.prevent>
        <Row type="flex" :gutter="gutterItem">
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002324')" prop="name">
              <Input v-model.trim="pageParams.name" clearable></Input>
            </Form-item>
          </Col>
          <Col :xxl="fourItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002325')" prop="code">
              <Input v-model.trim="pageParams.code" clearable></Input>
            </Form-item>
          </Col>
          <Col :xxl="threeItemCol" :xl="threeItemCol" :lg="twoItemCol" :md="oneItemCol">
            <FormItem :label="$t('key1002326')">
              <local-tabButton :tabButtonList="reservoirStatusList" @selectStatus="reservoirStatusBtn"></local-tabButton>
            </FormItem>
          </Col>
          <Col style="min-width: 200px;">
            <Button @click="reset" icon="md-refresh" class="mr10">{{ $t('key1000109') }}</Button>
            <Button type="primary" @click="search" icon="md-search">{{ $t('key1000361') }}</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <!--功能按钮操作区域-->
    <div class="operation_box">
      <!--新建库区-->
      <Button class="mr15" type="primary" @click="AddReservoirBtn"
        v-if="getPermission('ymsWarehouseBlock_insert')">{{ $t('key1002320') }}</Button>
      <!--批量打印条码-->
      <Button class="mr15" type="primary" @click="batchPrintingBarcodeBtn">{{ $t('key1002330') }}</Button>
    </div>
    <!--列表区域-->
    <div class="table_box">
      <Table
        ref="selection"
        highlight-row
        :loading="tableLoading"
        border
        max-height="530"
        :columns="tableColumns"
        :data="tableData"
        @on-selection-change="tableChange"
        @on-sort-change="sortChange">
      </Table>
      <Page
        :transfer="true"
        v-if="!tableLoading"
        :total="total"
        @on-change="changePage"
        show-total
        :page-size="pageParams.pageSize"
        show-elevator
        :current="pageParams.pageNum"
        show-sizer
        @on-page-size-change="changePageSize"
        placement="top"
        :page-size-opts="pageArray">
      </Page>
    </div>
    <!--新建库区弹窗-->
    <Modal v-model="reservoirModal" :title="reservoirModalTitle" width="600"
      :transfer="false" :mask-closable="false" @on-visible-change="reservoirModalChange">
      <Form ref="reservoirForm" :model="reservoirForm" :rules="ruleValidate" :label-width="labelWidth"
        :disabled="reservoirTalg === 'look'" @submit.native.prevent>
        <Row>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002327')" prop="ymsWarehouseId">
              <Select v-model="reservoirForm.ymsWarehouseId" transfer filterable style="width: 80%;" :disabled="reservoirTalg !== 'add'">
                <Option v-for="item in ymsWarehouseList" :key="item.ymsWarehouseId" :value="item.ymsWarehouseId">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002324')" prop="name">
              <Input clearable v-model.trim="reservoirForm.name" style="width: 80%;"></Input>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1002325')" prop="code">
              <Input clearable v-model.trim="reservoirForm.code" style="width: 80%;"></Input>
            </Form-item>
          </Col>
          <Col :xxl="oneItemCol" :xl="oneItemCol" :lg="oneItemCol" :md="oneItemCol">
            <Form-item :label="$t('key1001522')" prop="status">
              <Select v-model="reservoirForm.status" filterable transfer style="width: 80%;">
                <Option v-for="(item, index) in statusLists" :value="item.value" :key="index">{{ item.name }}</Option>
              </Select>
            </Form-item>
          </Col>
        </Row>
      </Form>
      <template #footer>
        <div style="text-align: center;">
          <Button @click="reservoirModal = false">{{ $t('key1000112') }}</Button>
          <Button type="primary" @click="reservoirBtn" v-if="reservoirTalg !== 'look'">{{ $t('key1000111') }}</Button>
        </div>
      </template>
    </Modal>
    <!--打印条码弹窗-->
    <setPrintBarcodeModal
      ref="printBarcode"
      :printBarcodeTitle="$t('key1002328')"
      :labelTitle="$t('key1002314')"
      :tableTitle="$t('key1002329')"
      :printColumns="printColumns"
      :printData="printData"
      :printViewParams="['codeBarcode', 'code']"
      @changePrintNum="changePrintNum"
      @printBarcodeModalChange="printBarcodeModalChange"
    ></setPrintBarcodeModal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from "@/components/mixin/common_mixin";
import api from '@/api/';
import setPrintBarcodeModal from "@/views/yms/components/basicSettings/components/setPrintBarcodeModal";
import {ENABLEDISABLESTATUS} from "@/utils/enum";
import {getEnableWarehouseData, getWarehouseName} from "@/utils/common";

export default {
  name: "reservoirManage",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      pageParams: {
        code: '',
        name: '',
        upDown: 'down',
        orderBy: 'createdTime',
        status: null,
        pageSize: 15,
        pageNum: 1
      },
      ymsWarehouseBlockId: null,
      total: 0,
      pageParamsStatus: false,
      reservoirStatusList: ENABLEDISABLESTATUS,
      tableColumns: [
        {
          type: 'selection',
          width: 70,
          align: 'center'
        },
        {
          type: 'index',
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000343'),
          width: 75,
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002314'),
          key: 'code',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002315'),
          key: 'name',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000328'),
          key: 'warehouseName',
          align: 'center',
          render(h, params) {
            return h('span', getWarehouseName(v.ymsWarehouseList, params.row.ymsWarehouseId));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000461'),
          key: 'status',
          align: 'center',
          render(h, params) {
            let status = params.row.status;
            let text = '';
            v.statusLists.map((item) => {
              if (item.value === status) {
                text = item.name;
              }
            });
            return h('span', {
              class: status === 1 ? 'openStatus' : 'stopStatus'
            }, text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002159'),
          key: 'createdTime',
          align: 'center',
          sortable: 'custom',
          sortType: 'desc',
          render: (h, params) => {
            return h('span', v.$uDate.dealTime(params.row.createdTime, 'fulltime'));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000319'),
          key: 'action',
          align: 'center',
          width: 300,
          render: (h, params) => {
            return h('optsButtonList', {
              props: {
                operationList: [
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000401'),
                    show: v.getPermission('ymsWarehouseBlock_detail'),
                    clickFn: () => {
                      v.lookReservoirBtn(params.row.ymsWarehouseBlockId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000985'),
                    show: v.getPermission('ymsWarehouseBlock_update'),
                    clickFn: () => {
                      v.editReservoirBtn(params.row.ymsWarehouseBlockId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462'),
                    show: params.row.status === 0 && v.getPermission('ymsWarehouseBlock_enable'),
                    clickFn: () => {
                      v.operationHandel('enable', params.row.ymsWarehouseBlockId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463'),
                    show: params.row.status === 1 && v.getPermission('ymsWarehouseBlock_disable'),
                    clickFn: () => {
                      v.operationHandel('disable', params.row.ymsWarehouseBlockId);
                    }
                  },
                  {
                    text: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000594'),
                    show: true,
                    clickFn: () => {
                      v.printData = [params.row];
                      v.$refs['printBarcode'].setPrintBarcodeModal = true;
                    }
                  }
                ]
              },
              on: {
                setWidth(value) {
                  if (value) {
                    v.optionBtnWidth.push(value);
                    params.column.width = Math.max(...v.optionBtnWidth);
                    v.$forceUpdate();
                  }
                }
              }
            });
          }
        }
      ],
      tableData: [],
      statusLists: [
        {value: 0, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000463')},
        {value: 1, name: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000462')}
      ],
      ruleValidate: {
        ymsWarehouseId: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002316'),
            trigger: 'change'
          }
        ],
        name: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002317'),
            trigger: 'blur'
          }
        ],
        code: [
          {
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002318'),
            trigger: 'blur'
          }
        ],
        status: [
          {
            type: 'number',
            required: true,
            message: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002319'),
            trigger: 'change'
          }
        ]
      },
      reservoirModal: false,
      reservoirModalTitle: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002320'),
      reservoirTalg: 'add',
      reservoirForm: {
        ymsWarehouseId: null,
        code: '',
        name: '',
        status: null
      },
      printColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002314'),
          key: 'code',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002315'),
          key: 'name',
          align: 'center'
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000318'),
          key: 'printQuantity',
          align: 'center',
          width: 150,
          render: (h, params) => {
            return h('InputNumber', {
              props: {
                min: 1,
                max: 999999,
                value: this.printData[params.index].printQuantity,
                size: 'small'
              },
              on: {
                input: (val) => {
                  this.printData[params.index].printQuantity = val;
                }
              }
            });
          }
        }
      ],
      printData: [],
      ymsWarehouseList: [],
    };
  },
  created() {
    this.ymsWarehouseList = [];
    this.reservoirStatusBtn(0, null);
    getEnableWarehouseData(1).then((data) => {
      if (data && data.length > 0) {
        this.ymsWarehouseList = data;
      }
    });
    this.search();
  },
  methods: {
    // 查询按钮
    search() {
      this.pageParams.pageNum = 1;
      this.getList();
    },
    // 重置按钮
    reset() {
      let v = this;
      v.$refs['pageParams'].resetFields();
      v.reservoirStatusBtn(0, null);
      v.getList();
    },
    // 获取列表数据
    getList() {
      let v = this;
      v.tableData = [];
      v.total = 0;
      if (v.getPermission('ymsWarehouseBlock_query')) {
        v.tableLoading = true;
        v.axios.post(api.post_ymsWarehouseBlock_query, v.pageParams).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            let list = data.list || [];
            list.map((item) => {
              item['printQuantity'] = 1;
            });
            v.tableData = list;
            v.total = data.total;
            v.$nextTick(() => {
              v.tableLoading = false;
            });
          } else {
            v.tableLoading = false;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 新建库区
    AddReservoirBtn() {
      this.reservoirTalg = 'add';
      this.reservoirModal = true;
      this.reservoirModalTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002320');
    },
    // 查看库区
    lookReservoirBtn(ymsWarehouseBlockId) {
      this.reservoirTalg = 'look';
      this.reservoirModalTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002321');
      this.getReservoirDetails(ymsWarehouseBlockId);
    },
    // 编辑库区
    editReservoirBtn(ymsWarehouseBlockId) {
      this.reservoirTalg = 'edit';
      this.reservoirModalTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002322');
      this.getReservoirDetails(ymsWarehouseBlockId);
    },
    // 获取库区详情数据
    getReservoirDetails(ymsWarehouseBlockId) {
      this.ymsWarehouseBlockId = ymsWarehouseBlockId;
      this.axios.get(api.get_ymsWarehouseBlock + ymsWarehouseBlockId, {loading: true}).then(response => {
        if (response.data.code === 0) {
          this.reservoirModal = true;
          this.reservoirForm = response.data.datas;
        }
      });
    },
    // 选取库区状态
    reservoirStatusBtn(index, value) {
      let v = this;
      v.pageParams.status = value;
      v.reservoirStatusList.forEach((n, i) => {
        n.selected = i === index;
      });
    },
    // 新增、编辑库区弹窗的确定按钮
    reservoirBtn() {
      let v = this;
      let url = '';
      let method = 'post';
      let text = '';
      if (v.reservoirTalg === 'add') {
        url = api.post_ymsWarehouseBlock;
        method = 'post';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001488');
      } else if (v.reservoirTalg === 'edit') {
        url = api.put_ymsWarehouseBlock;
        method = 'put';
        text = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002279');
      }
      v.$refs['reservoirForm'].validate((valid) => {
        if (valid) {
          let query = {
            method: method,  // 请求的方法
            url: url,  // 接口
            data: Object.assign({}, v.reservoirForm),  // 参数
            config: {loading: true}
          };
          v.axios(query).then(response => {
            if (response.data.code === 0) {
              v.reservoirModal = false;
              v.$Message.success(text);
              v.pageParamsStatus = true;
            }
          });
        }
      });
    },
    // 启用、停用仓库按钮
    operationHandel(type, ymsWarehouseBlockId) {
      let url = '';
      if (type === 'disable') {
        url = api.put_ymsWarehouseBlock_disable;
      } else {
        url = api.put_ymsWarehouseBlock_enable;
      }
      this.axios.put(url + ymsWarehouseBlockId).then(response => {
        if (response.data.code === 0) {
          this.pageParamsStatus = true;
          this.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000489'));
        }
      });
    },
    // 监听库区弹窗
    reservoirModalChange(value) {
      if (!value) {
        this.$refs['reservoirForm'].resetFields();
        this.reservoirTalg = 'add';
        this.reservoirModalTitle = aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002320');
      }
    },
    // 勾选列表数据
    tableChange(data) {
      if (data) {
        this.printData = data;
      }
    },
    // 批量打印条码
    batchPrintingBarcodeBtn() {
      if (this.printData.length > 0) {
        this.$refs.printBarcode.setPrintBarcodeModal = true;
      } else {
        this.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002323'));
        return false;
      }
    },
    // 统一设置打印数量
    changePrintNum(value) {
      let v = this;
      if (v.printData.length > 0) {
        v.printData.forEach((n, i) => {
          v.$set(v.printData[i], 'printQuantity', value);
        });
      }
    },
    // 关闭打印设置条码弹窗时，重置勾选数据
    printBarcodeModalChange() {
      let v = this;
      v.printData = [];
      v.$refs['selection'].selectAll(false);
    },
    // 时间排序
    sortChange(data) {
      let obj = {
        desc: 'down',
        asc: 'up'
      };
      this.pageParams.upDown = obj[data.order];
      this.pageParams.orderBy = data.key;
      this.pageParamsStatus = true;
    }
  },
  watch: {
    pageParamsStatus(value) {
      let v = this;
      if (value) {
        v.getList();
        v.pageParamsStatus = false;
      }
    }
  },
  components: {
    setPrintBarcodeModal
  }
};
</script>

<style scoped>

</style>
